import React,{useState} from "react";
import { useParams } from "react-router-dom";
import { EDIT_CAMPAIGN_LINK } from "../../../constants/constants";
import client from "../../../api";
import { notifyError, notifySuccess } from "../../../helper";

const CopyCampaignModelWindow = (props) => {
    const { setDisplayCopyModelWindow, displayCopyModelWindow } = props;
    const api = client();
    const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    
    const copyCampaign = async () => {
        try{
            setLoading(true);
            const payload = {
                campaign_id: campaignID,
            }
            
            const response = await api.post('/v1/campaign/duplicate', payload);
            if(response.status === 200 || response.status === 201){
                notifySuccess('Campaign copied successfully');
                setLoading(false);
                setTimeout(()=>{
                    window.location.href = EDIT_CAMPAIGN_LINK.replace(':campaignID',response.data.campaignID);
                },1000);
            }                
        } catch(error){
            console.log('error.message',error);
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to copy Campaign');
        }
    }
    
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Copy Campaign</h2>
                    <p>This modal allows to copy the campaign with options to Copy/Save  or cancel the changes.</p>
                    {/* <div className="form-fields">
                        <div className="field-wrap">
                            <label className="label-xs">Campaign Title</label>
                            <input 
                                type="text" 
                                name="campaign-name" 
                                onChange={(e)=>{
                                    handleInputField(e.target.value)}
                                }
                                onFocus={onFocus} 
                                onBlur={onBlur}
                                value={campaignName}
                                />

                            {error ? <span className="validation-error">{error}</span> :''}

                        </div>
                    </div> */}
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "next-btn button--loading":"next-btn"} 
                            disabled={loading}
                            onClick={()=>copyCampaign()}>
                                <span className="button--text">Copy</span>
                        </button>
                        
                        <button className="cancel-btn" onClick={()=>setDisplayCopyModelWindow(!displayCopyModelWindow)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default CopyCampaignModelWindow;